import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_APPRAISALS_PREFERENCES_FAILURE, POST_APPRAISALS_PREFERENCES_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { getHomesaleInfo, updateAppraisalPreferences, postAppraisalPreferences } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const BrokerPreferencesCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { appraisalPreferences, isReadOnly, appraisalsSelected, fileId, homesaleId } = props;
  const tabs = [{ header: appraisalsSelected ? 'Appraisal Preferences' : 'BMA Preferences', order: 1 }];
  let fieldName = appraisalsSelected ? 'Appraisal Request Letter Sent' : 'Broker Request Letter Sent';

  let appraisal = appraisalPreferences ? appraisalPreferences.find(a => a.isAppraisal === true) : null;
  let bma = appraisalPreferences ? appraisalPreferences.find(a => a.isAppraisal === false) : null;
  
  const appraisalSummaries = [
    {
      header: fieldName,
      accessorKey: 'brokerRequestSentOn',
      type: 'date',
      required: false,
      value: appraisal ? appraisal.brokerRequestSentOn : '',
      tab: 1
    },
    {
      header: 'Number of Appraisals Preferred',
      accessorKey: 'numAppraisalsPreferred',
      type: 'number',
      required: false,
      value: appraisal ? appraisal.numAppraisalsPreferred : '',
      tab: 1
    },
    {
      header: 'Preferred Appointment',
      accessorKey: 'preferredAppointment',
      type: 'date',
      required: false,
      value: appraisal ? appraisal.preferredAppointment : '',
      tab: 1
    },
    {
      header: 'Approx Start Date',
      accessorKey: 'approxStartDate',
      type: 'date',
      required: false,
      value: appraisal ? appraisal.approxStartDate : '',
      tab: 1
    },
    // {
    //   header: 'Home for Listing',
    //   accessorKey: 'homeForListing',
    //   type: 'text',
    //   required: false,
    //   hideInModal: true,
    //   value: appraisal ? appraisal.homeForListing : '',
    //   tab: 1
    // }
  ];

  const bmaSummaries = [
    {
      header: fieldName,
      accessorKey: 'brokerRequestSentOn',
      type: 'date',
      required: false,
      value: bma ? bma.brokerRequestSentOn : '',
      tab: 1
    },
    {
      header: 'Number of BMAs Preferred',
      accessorKey: 'numAppraisalsPreferred',
      type: 'number',
      required: false,
      value: bma ? bma.numAppraisalsPreferred : '',
      tab: 1
    },
    {
      header: 'Preferred Appointment',
      accessorKey: 'preferredAppointment',
      type: 'date',
      required: false,
      value: bma ? bma.preferredAppointment : '',
      tab: 1
    },
    {
      header: 'Goal For Listing Date',
      accessorKey: 'approxStartDate',
      type: 'date',
      required: false,
      value: bma ? bma.approxStartDate : '',
      tab: 1
    },
    {
      header: 'Review Call Complete',
      accessorKey: 'isReviewCallComplete',
      type: 'checkbox',
      required: false,
      value: bma ? bma.isReviewCallComplete : false,
      tab: 1
    },
    
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    if(appraisalsSelected) {
      if (appraisal) {
        let newValues = { ...appraisal };

        newValues.numAppraisalsPreferred = values.numAppraisalsPreferred;
        newValues.preferredAppointment = values.preferredAppointment === '' ? null : values.preferredAppointment;
        newValues.approxStartDate = values.approxStartDate === '' ? null : values.approxStartDate;
        newValues.homeForListing = values.homeForListing;
        newValues.brokerRequestSentOn = values.brokerRequestSentOn === '' ? null : values.brokerRequestSentOn;
        
        newValues.isReviewCallComplete = values.isReviewCallComplete;


        const resp = await props.updateAppraisalPreferences(fileId, newValues);
        if (resp.type === UPDATE_APPRAISALS_PREFERENCES_FAILURE) {
          props.showToast('Failed to update appraisal preferences info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          await props.getHomesaleInfo(fileId);
          setIsLoading(false);
          return true;
        }
      } else {
        let newValues = {
          homesaleId: homesaleId,
          isAppraisal: true,
          numAppraisalsPreferred: values.numAppraisalsPreferred,
          preferredAppointment: values.preferredAppointment === '' ? null : values.preferredAppointment,
          approxStartDate: values.approxStartDate === '' ? null : values.approxStartDate,
          homeForListing: values.homeForListing,
          brokerRequestSentOn: values.brokerRequestSentOn === '' ? null : values.brokerRequestSentOn,
          isReviewCallComplete: values.isReviewCallComplete
        }
         const resp = await props.postAppraisalPreferences(fileId, newValues);
        if (resp.type === POST_APPRAISALS_PREFERENCES_FAILURE) {
          props.showToast('Failed to create appraisal preferences info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          await props.getHomesaleInfo(fileId);
          setIsLoading(false);
          return true;
        }
      }
    }
    else {
      if (bma) {
        let newValues = { ...bma };

        newValues.numAppraisalsPreferred = values.numAppraisalsPreferred;
        newValues.preferredAppointment = values.preferredAppointment === '' ? null : values.preferredAppointment;
        newValues.approxStartDate = values.approxStartDate === '' ? null : values.approxStartDate;
        newValues.homeForListing = values.homeForListing;
        newValues.brokerRequestSentOn = values.brokerRequestSentOn === '' ? null : values.brokerRequestSentOn;
        
        newValues.isReviewCallComplete = values.isReviewCallComplete;


        const resp = await props.updateAppraisalPreferences(fileId, newValues);
        if (resp.type === UPDATE_APPRAISALS_PREFERENCES_FAILURE) {
          props.showToast('Failed to update appraisal preferences info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          await props.getHomesaleInfo(fileId);
          setIsLoading(false);
          return true;
        }
      } else {
        let newValues = {
          homesaleId: homesaleId,
          isAppraisal: false,
          numAppraisalsPreferred: values.numAppraisalsPreferred,
          preferredAppointment: values.preferredAppointment === '' ? null : values.preferredAppointment,
          approxStartDate: values.approxStartDate === '' ? null : values.approxStartDate,
          homeForListing: values.homeForListing,
          brokerRequestSentOn: values.brokerRequestSentOn === '' ? null : values.brokerRequestSentOn,
          isReviewCallComplete: values.isReviewCallComplete
        }
         const resp = await props.postAppraisalPreferences(fileId, newValues);
        if (resp.type === POST_APPRAISALS_PREFERENCES_FAILURE) {
          props.showToast('Failed to create appraisal preferences info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          await props.getHomesaleInfo(fileId);
          setIsLoading(false);
          return true;
        }
      }
    }
  };

  // const bmaPreferencesButtons = ({ ...rest }) => {
  //   return (
  //     <>
  //       {isOrderingList && (
  //         <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
  //           <DialogActions sx={{ p: '1.25rem' }}>
  //             <Spinner />
  //           </DialogActions>
  //         </Box>
  //       )}
  //       {!isOrderingList && !appraisalsSelected && (
  //         <Box sx={{ display: 'flex', flexDirection: 'column' }}>
  //           <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
  //             <Box
  //               sx={{
  //                 display: 'flex',
  //                 justifyContent: 'space-between',
  //                 alignItems: 'center',
  //                 padding: '0 10px'
  //               }}
  //             >
  //               {!details?.homesale?.homesaleInfo.brokerRequestListSent && !isOrderingList && (
  //                 <Button
  //                   color="secondary"
  //                   variant="contained"
  //                   sx={{ maxHeight: '40px', marginTop: '8px' }}
  //                   onClick={async () => await orderList()}
  //                 >
  //                   Request Broker List
  //                 </Button>
  //               )}
  //             </Box>
  //           </Box>
  //           {details?.authHomesale?.homesale?.brokerRequestSent && !isOrderingList && (
  //             <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
  //               <Typography color="secondary" sx={{ marginTop: '10px' }}>
  //                 <FontAwesomeIcon size="1x" icon={['fas', 'fa-check-circle']} color="#5D9878" sx={{ marginRight: '13px' }} /> Broker List
  //                 request has been sent,
  //                 <Link onClick={async () => await orderList()} sx={{ cursor: 'pointer' }}>
  //                   click here
  //                 </Link>{' '}
  //                 to resend.
  //               </Typography>
  //             </Box>
  //           )}
  //         </Box>
  //       )}
  //       {!isReadOnly && appraisalsSelected && (
  //         <Box sx={{ display: 'flex', flexDirection: 'column' }}>
  //           <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
  //             <Box
  //               sx={{
  //                 display: 'flex',
  //                 justifyContent: 'space-between',
  //                 alignItems: 'center',
  //                 padding: '0 10px'
  //               }}
  //             >
  //               {!details?.homesale?.homesaleInfo.brokerRequestListSent && !isOrderingList && (
  //                 <Button
  //                   color="secondary"
  //                   variant="contained"
  //                   sx={{ maxHeight: '40px', marginTop: '8px' }}
  //                   onClick={async () => await orderList()}
  //                 >
  //                   Request Appraiser List
  //                 </Button>
  //               )}
  //             </Box>
  //           </Box>
  //           {!details?.homesale?.homesaleInfo.brokerRequestListSent && !isOrderingList && (
  //             <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
  //               <Typography color="secondary" sx={{ marginTop: '10px' }}>
  //                 <FontAwesomeIcon size="1x" icon={['fas', 'fa-check-circle']} color="#5D9878" sx={{ marginRight: '13px' }} /> Appraiser
  //                 List request has been sent,
  //                 <Link onClick={async () => await orderList()} sx={{ cursor: 'pointer' }}>
  //                   click here
  //                 </Link>{' '}
  //                 to resend.
  //               </Typography>
  //             </Box>
  //           )}
  //         </Box>
  //       )}
  //     </>
  //   );
  // };

  return (
    <EditableCard
      tabs={tabs}
      summaries={appraisalsSelected ? appraisalSummaries : bmaSummaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
      //ButtonComponent={bmaPreferencesButtons}
    />
  );
};

export default compose(
  connect(null, {
    updateAppraisalPreferences,
    postAppraisalPreferences,
    showToast,
    getHomesaleInfo
  })
)(BrokerPreferencesCard);
